import styled from "styled-components";

const CircledIcon = styled.div<{ $bgColor: string }>`
  background-color: ${({ $bgColor }) => $bgColor};
  padding: 7px 8px;
  border-radius: 16px;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
`;

export default CircledIcon;
